export default __webpack_public_path__ + "static/media/s1.c658b5b5.jpg";